import { RestMethod } from "app/_helpers/ApiConfig/RestMethod";

export async function excelExportEmail(filter) {
  let url = "global-configuration/ehs-module/excel-export-email?";

  if (filter) url += filter;
  try {
    const response = await RestMethod.POST(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function excelExportAlert(filter) {
  let url = "global-configuration/ehs-module/excel-export-alert?";

  if (filter) url += filter;
  try {
    const response = await RestMethod.POST(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
